module.exports = __webpack_public_path__ + "static/img/5-en.205969c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/title-level/img/5-en.png
// module id = E79t
// module chunks = 1